import { ExtensionSlot, LayoutProps } from 'piral-core';
import * as React from 'react';
import { LegacyNavigationHandler } from '../infrastructure/legacy';

export const LayoutDefault: React.FC<LayoutProps> = (props) => {
  return <div className="layout-wrapper">
    <LegacyNavigationHandler />
    <div className="layout layout--default">
      <ExtensionSlot name="Cloud.Topbar" />
      <div className="layout_content">
        <ExtensionSlot name="Cloud.Sidebar" />
        <main>{props.children}</main>
      </div>
    </div> 
  </div>
};
